import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
interface CtaButtonProps {
  text: string;
  className?: string;
}
export function CtaButton({
  text,
  className = ''
}: CtaButtonProps) {
  const handleClick = () => {
    const element = document.getElementById('compra');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <button onClick={handleClick} className={`group relative inline-flex items-center justify-center gap-3 bg-[#c0703a] hover:bg-[#a85d2e] text-white font-oswald uppercase font-bold text-xl md:text-3xl py-5 px-8 md:px-12 rounded-lg shadow-xl transition-all duration-300 animate-cf-pulse w-full md:w-auto text-center leading-tight ${className}`} data-id="element-70">
      <span data-id="element-71">{text}</span>
      <ArrowRightIcon className="w-6 h-6 md:w-8 md:h-8 group-hover:translate-x-2 transition-transform" data-id="element-72" />
    </button>;
}